import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericApiError } from '@/_shared/types/apiError';
import { API_ORGANIZATIONS, KEY_GET_ORGANIZATIONS } from '../constants';
import { getDefaultOrganization } from '../helpers/getDefaultOrganization';
import { MOCK_RESPONSE_GET_ORGANIZATIONS } from '../mocks';
import { Organization, Organizations } from '../types';

export type CallParamsGetOrganizations = {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetOrganizations = Organizations;

type CallErrorGetOrganizations = GenericApiError;

type CallSelectorsGetOrganizations = {
  data: Organization[];
  totalItems: number;
  defaultOrganization: string;
  defaultOrganizationId: string;
  vatNumber: string;
};

export const getOrganizationsCall = createGeneralCall<
  CallParamsGetOrganizations,
  CallResponseGetOrganizations,
  CallErrorGetOrganizations,
  CallSelectorsGetOrganizations
>({
  id: KEY_GET_ORGANIZATIONS,
  url: () => () => API_ORGANIZATIONS(),
  method: 'get',
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_GET_ORGANIZATIONS
    : undefined,
  selectors: {
    data: ({ selectors }) => createSelector(selectors.response, res => res?.data || []),
    totalItems: ({ selectors }) => createSelector(selectors.response, res => res?.totalItems),
    defaultOrganization: ({ selectors }) =>
      createSelector(selectors.response, res => getDefaultOrganization(res?.data)?.name || ''),
    defaultOrganizationId: ({ selectors }) =>
      createSelector(
        selectors.response,
        res => getDefaultOrganization(res?.data)?.organizationId || '',
      ),
    vatNumber: ({ selectors }) =>
      createSelector(selectors.response, res => getDefaultOrganization(res?.data)?.vatNumber || ''),
  },
});
